import { mode } from "@chakra-ui/theme-tools";
export const textareaStyles = {
  components: {
    Textarea: {
      baseStyle: {
        field: {
          fontWeight: 400,
          borderRadius: "0.5rem",
        },
      },

      variants: {
        main: (props) => ({
          field: {
            bg: mode("transparent", "rgba(17, 24, 39, 0.5)")(props),
            border: "1px solid !important",
            color: mode("secondaryGray.900", "gray.200")(props),
            borderColor: mode("secondaryGray.100", "gray.700")(props),
            borderRadius: "0.5rem",
            fontSize: "sm",
            p: "20px",
            _placeholder: { color: mode("secondaryGray.400", "gray.600") },
            _focus: {
              borderColor: mode("secondaryGray.100", "gray.600")(props),
            },
          },
        }),
        auth: (props) => ({
          field: {
            bg: mode("white", "transparent")(props),
            border: "1px solid",
            borderColor: mode("secondaryGray.100", "gray.700")(props),
            borderRadius: "0.5rem",
            _placeholder: { color: mode("secondaryGray.600", "gray.600") },
            _focus: {
              borderColor: mode("secondaryGray.100", "gray.600")(props),
            },
          },
        }),
        authSecondary: (props) => ({
          field: {
            bg: mode("white", "transparent")(props),
            border: "1px solid",
            borderColor: mode("secondaryGray.100", "gray.700")(props),
            borderRadius: "0.5rem",
            _placeholder: { color: mode("secondaryGray.600", "gray.600") },
            _focus: {
              borderColor: mode("secondaryGray.100", "gray.600")(props),
            },
          },
        }),
        search: (props) => ({
          field: {
            border: "none",
            py: "11px",
            borderRadius: "inherit",
            _placeholder: { color: mode("secondaryGray.600", "gray.600") },
          },
        }),
        filled: (props) => ({
          field: {
            bg: mode("gray.100", "gray.700")(props),
            border: "1px solid",
            borderColor: mode("gray.200", "gray.600")(props),
            color: mode("secondaryGray.900", "white")(props),
            borderRadius: "0.5rem",
            fontSize: "sm",
            p: "20px",
            _placeholder: { color: mode("gray.500", "gray.400") },
            _hover: {
              bg: mode("gray.100", "gray.700")(props),
            },
            _focus: {
              bg: mode("white", "gray.600")(props),
              borderColor: mode("brand.500", "brand.400")(props),
            },
            _disabled: {
              opacity: 0.6,
              cursor: "not-allowed",
            },
          },
        }),
      },
    },
  },
};
